import { withStyles } from '../../../utils';
import MaterialSymbol from '../../DataDisplay/MaterialSymbol/MaterialSymbol';
import { ScrollDirection } from './useTabStripScroll';

import styles from './ScrollButton.module.scss';

const classes = withStyles(styles);

type ScrollButtonProps = {
  direction: ScrollDirection;
  /** A mouse is over the strip and the edge this arrow points to is clipped. */
  isShown: boolean;
  onClick: () => void;
};

/**
 * An arrow over one edge of a scrolling tab strip. Mouse-only: keyboard users move between tabs with the arrow
 * keys, which already scrolls the focused tab into view, so it stays out of the tab order and the accessibility
 * tree.
 */
export default function ScrollButton({ direction, isShown, onClick }: ScrollButtonProps) {
  return (
    <button
      type="button"
      tabIndex={-1}
      aria-hidden
      className={classes('scrollButton', direction)}
      data-testid={`cardTabsScroll-${direction}`}
      data-shown={isShown || undefined}
      onClick={onClick}
    >
      <MaterialSymbol icon={direction === 'start' ? 'chevron_left' : 'chevron_right'} size="20px" />
    </button>
  );
}
